import { ActionNode } from '../Action/TypedNode'
import { QueryModel } from '../Query/ViewModel'
import { ActionCallQueryDefinition } from './TypedDefinition'

import type { ActionSpecific } from '../Action/TypedNode'
import type { AnyExpressionSpecific } from '../Mustache'
import type { TypedSpecific, ViewScope } from '@rehaje/core'
import type { RecursionType, TRecord } from '@rehaje/shared'

export interface ActionCallQuerySpecific extends ActionSpecific {
  props: {
    params?: RecursionType<TypedSpecific>
    queryId?: AnyExpressionSpecific | string
  }
  type: `Action.CallQuery`
}

export interface CallQueryProps {
  params?: TRecord
  queryId?: string
}

export class ActionCallQueryNode extends ActionNode {
  static definition = ActionCallQueryDefinition

  override async handler(props: CallQueryProps, scope: ViewScope) {
    if (props.queryId) {
      const model = scope.variables[props.queryId]
      if (model instanceof QueryModel) {
        model.trigger(props.params)
      }
    }
  }
}

declare global {
  export interface RehajeSpecifics {
    'Action.CallQuery': ActionCallQuerySpecific
  }
  export interface RehajeTypedNodes {
    'Action.CallQuery': ActionCallQueryNode
  }
}
